import { IAdmin } from "../../Utils/types";
import { ThunkAction } from "redux-thunk";
import { AppState, AppActions } from "../Store/store";
import { adminApi } from "../api";
import { emailValidation } from "../../Utils/validators";

interface IAdminsState {
  admins: IAdmin[],
  status: string,
  editStatus: string,
  newAdmin: any,
  addStatus: string
}
const adminState: IAdminsState = {
  admins: [],
  status: 'initial',
  editStatus: 'initial',
  newAdmin: {
    id: {
      valid: false,
      touched: false,
      value: ''
    },
    level: 0,
    email: {
      valid: false,
      touched: false,
      value: ''
    }
  },
  addStatus: 'initial'
}

// Action types
const GET_ADMINS = 'admins/GET_ADMINS';
const SET_ADMINS_STATUS = 'admins/SET_ADMINS_STATUS';
const SET_ADMINS_EDIT_STATUS = 'admins/SET_ADMINS_EDIT_STATUS';
const REMOVE_ADMIN = 'admins/REMOVE_ADMIN';
const SET_NEW_ADMIN = 'admins/SET_NEW_ADMIN';
const SET_ADMINS_ADD_STATUS = 'admins/SET_ADMINS_ADD_STATUS';
const ADD_ADMIN = 'admins/ADD_ADMIN';
const CLEAR_NEW_ADMIN = 'admins/CLEAR_NEW_ADMIN';
const UPDATE_LEVEL_ADMIN = 'admins/UPDATE_LEVEL_ADMIN';

// Selectors
export const adminsSelector = (state: AppState) => state.admins.admins;
export const adminsStatusSelector = (state: AppState) => state.admins.status;
export const adminsEditStatusSelector = (state: AppState) => state.admins.editStatus;
export const newAdminSelector = (state: AppState) => state.admins.newAdmin;
export const addAdminStatusSelector = (state: AppState) => state.admins.addStatus;

// Reducer
export function adminsReducer(state: IAdminsState = adminState, action: any) {
  switch (action.type) {
    case GET_ADMINS: {
      return {
        ...state,
        admins: [...action.payload]
      }
    }
    case SET_ADMINS_STATUS: {
      return {
        ...state,
        status: action.payload
      }
    }
    case SET_ADMINS_ADD_STATUS: {
      return {
        ...state,
        addStatus: action.payload
      }
    }
    case REMOVE_ADMIN: {
      const newArray = [...state.admins];
      const id = newArray.findIndex((item) => item.id === action.payload)
      newArray.splice(id);
      console.log(newArray);
      
      return {
        ...state,
        admins: newArray
      }
    }
    case ADD_ADMIN: {
      return {
        ...state,
        admins: [
          ...state.admins,
          {
            level: action.level,
            id: action.id,
            email: action.email
          }
        ]
      }
    }
    case SET_NEW_ADMIN: {
      return {
        ...state,
        newAdmin: {
          ...state.newAdmin,
          [action.name]: action.payload
        }
      }
    }
    case CLEAR_NEW_ADMIN: {
      return {
        ...state,
        newAdmin: {
          ...adminState.newAdmin
        }
      }
    }
    case UPDATE_LEVEL_ADMIN: {
      const newArray = [...state.admins];
      const id = newArray.findIndex((item) => item.id === action.id)
      newArray[id].level = action.level;
      return {
        ...state,
        admins: newArray
      }
    }

    case SET_ADMINS_EDIT_STATUS: {
      return {
        ...state,
        editStatus: action.payload
      }
    }

    default: {
      return state;
    }
  }
}

// Actions
interface GetAdminsType {
  type: typeof GET_ADMINS,
  payload: IAdmin[]
}
export function getAdmins(): ThunkAction<Promise<void>, AppState, unknown, AppActions> {
  return async (dispatch) => {
    const response = await adminApi.getAdmins();
    dispatch(setAdminsStatus('loading'));
    dispatch({
      type: GET_ADMINS,
      payload: response.admins
    });
    dispatch(setAdminsStatus('loaded'));
  }
}
interface SetAdminsStatusType {
  type: typeof SET_ADMINS_STATUS,
  payload: string
}
export function setAdminsStatus(payload: string): SetAdminsStatusType {
  return {
    type: SET_ADMINS_STATUS,
    payload
  }
}
interface SetAdminsEditStatusType {
  type: typeof SET_ADMINS_EDIT_STATUS,
  payload: string
}
export function setAdminsEditStatus(payload: string): SetAdminsEditStatusType {
  return {
    type: SET_ADMINS_EDIT_STATUS,
    payload
  }
}
interface RemoveAdminType {
  type: typeof REMOVE_ADMIN,
  payload: number
}
export function removeAdmin(id: number): ThunkAction<Promise<void>, AppState, unknown, AppActions> {
  return async (dispatch) => {
    dispatch(setAdminsEditStatus('loading'));
    const response = await adminApi.removeAdmin(id);
    if (response.valid) {
      dispatch({
        type: REMOVE_ADMIN,
        payload: id
      });
    }
    dispatch(setAdminsEditStatus('valid'));
  }
}
interface AddAdminType {
  type: typeof ADD_ADMIN,
  id: number,
  level: number,
  email: string
}
export function addAdmin(): ThunkAction<Promise<void>, AppState, unknown, AppActions> {
  return async (dispatch, getState) => {
    dispatch(setAdminsAddStatus('loading'));
    const state = getState().admins.newAdmin;
    const payload = {
      id: state.id.value,
      level: state.level.value,
      email: state.email.value
    }
    const response = await adminApi.addAdmin(payload);
    if (response.valid) {
      dispatch({
        type: ADD_ADMIN,
        id: payload.id,
        level: payload.level,
        email: payload.email
      });
      dispatch(clearNewAdmin());
      dispatch(setAdminsAddStatus('valid'));
    } else {
      dispatch(setAdminsAddStatus('invalid'));
    }
  }
}
interface SetAdminsAddStatusType {
  type: typeof SET_ADMINS_ADD_STATUS,
  payload: string
}
export function setAdminsAddStatus(payload: string): SetAdminsAddStatusType {
  return {
    type: SET_ADMINS_ADD_STATUS,
    payload
  }
}
interface SetNewAdminType {
  type: typeof SET_NEW_ADMIN,
  name: string,
  payload: {
    touched: boolean,
    valid: boolean,
    value: any
  }
}
export function setNewAdmin(name: string, value: any): SetNewAdminType {
  let valid = false;
  if (name === 'email') {
    valid = emailValidation(value);
  } else if (name === 'id' || name === 'level') {
    valid = typeof +value === "number";
  }

  return {
    type: SET_NEW_ADMIN,
    name,
    payload: {
      touched: true,
      valid,
      value
    }
  }
}
interface ClearNewAdminType {
  type: typeof CLEAR_NEW_ADMIN
}
export function clearNewAdmin(): ClearNewAdminType {
  return {
    type: CLEAR_NEW_ADMIN
  }
}
interface UpdateLevelAdminType {
  type: typeof UPDATE_LEVEL_ADMIN,
  id: number,
  level: number
}
export function updateLevelAdmin(id: number, level: number): ThunkAction<Promise<void>, AppState, unknown, AppActions> {
  return async (dispatch) => {
    dispatch(setAdminsEditStatus('loading'));
    const response = await adminApi.updateLevelAdmin(id, level);
    if (response.valid) {
      dispatch({
        type: UPDATE_LEVEL_ADMIN,
        id,
        level
      });
    }
    dispatch(setAdminsEditStatus('valid'));
  }
}

export type AdminsActions =
  GetAdminsType
  | SetAdminsStatusType
  | RemoveAdminType
  | UpdateLevelAdminType
  | SetAdminsEditStatusType
  | AddAdminType
  | SetNewAdminType
  | SetAdminsAddStatusType
  | ClearNewAdminType;